/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlocks.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Blocks
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, September 30, 2018 - 10:36:00 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/30/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    BLOCK_LIST_CONTAINER_LOADED,
    BLOCK_LIST_CONTAINER_UNLOADED,
    BLOCK_LIST_TABLE_LOADED,
    BLOCK_LIST_TABLE_UNLOADED,

    BLOCK_LIST_CHANGE_GROUP,

    BLOCK_SELECT_ROW,
    BLOCK_ADD,
    BLOCK_EDIT,
    BLOCK_DELETE,
    BLOCK_OPEN_WARNING,
    BLOCK_CLOSE_WARNING,
    BLOCK_DELETE_DISABLE,

    BLOCK_EDIT_CONTAINER_LOADED,
    BLOCK_EDIT_CONTAINER_UNLOADED,
    BLOCK_EDIT_FORM_LOADED,
    BLOCK_EDIT_FORM_UNLOADED,
    BLOCK_EDIT_DATA_LOAD,
    BLOCK_EDIT_CONTAINER_SUBMIT,
    BLOCK_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlocks';

const defaultState = {
    refreshList: false,
    danger: false,
    blockid: 0,
    blockgroupid: 0,
    parentid: 0,
    name: '',
    description: '',
    shortkey: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case BLOCK_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blocks: action.payload[0] ? action.payload[0].records : null,
                blockgroups: action.payload[1] ? action.payload[1].records : null,
                itempath: action.payload[2] ? action.payload[2].records : []
            }
        case BLOCK_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case BLOCK_LIST_CHANGE_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blocks: action.payload[0] ? action.payload[0].records : null,
                itempath: action.payload[2] ? action.payload[2].records : []
            }
        case BLOCK_SELECT_ROW:
            return {
                ...state,
                type: action.itemtype,
                itemid: action.id
            }
        case BLOCK_ADD:
            return {
                ...state
            }
        case BLOCK_EDIT:
            return {
                ...state,
                blockid: action.id
            }
        case BLOCK_DELETE:
            return {
                ...state,
                blockid: null
            }
        case BLOCK_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case BLOCK_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case BLOCK_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case BLOCK_EDIT_CONTAINER_LOADED:
        case BLOCK_EDIT_DATA_LOAD:
            return {
                ...state,
                blockid: action.payload[0] ? action.payload[0].blockid : 0,
                blockgroupid: action.payload[0] ? action.payload[0].blockgroupid : 0,
                parentid: action.payload[0] ? action.payload[0].parentid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                shortkey: action.payload[0] ? action.payload[0].shortkey : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case BLOCK_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case BLOCK_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case BLOCK_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case BLOCK_LIST_CONTAINER_UNLOADED:
        case BLOCK_LIST_TABLE_UNLOADED:
        case BLOCK_EDIT_CONTAINER_UNLOADED:
        case BLOCK_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlocks.js